<template>
  <div class="question">
    <div class="content">
      <div v-for="content in contents">
        <img :src="content.image" alt="">
        <p v-html="content.text">
        </p>
        <input
          type="text"
          name="input"
          :placeholder="input.placeholder"
          v-on:keyup.13="onSubmit"
          v-model="inputVal"
          v-if="input.isActive"
        />
        <input
          type="text"
          name="input"
          :placeholder="secondInput.placeholder"
          v-on:keyup.13="onSubmit"
          v-model="secondInputVal"
          v-if="secondInput.isActive"
        />
      </div>
    </div>

    <div class="button-container">
      <div class="button-caption" v-for="option in options">
        <router-link v-if="option.type != 'done' && option.isOption && !input.isActive && !option.isHttpRequest" :class="{ 'yes': option.type == 'yes', 'no': option.type == 'no', 'continue': option.type == 'continue', }" :to="{ name: 'Option', params: { id: option.id } }">
          <span v-if="option.type == 'continue'">DEVAM ET</span>
          <span v-if="option.type == 'yes'">EVET</span>
          <span v-if="option.type == 'no'">HAYIR</span>
        </router-link>

        <router-link v-if="option.type != 'done' && !option.isOption && !input.isActive && !option.isHttpRequest" :class="{ 'yes': option.type == 'yes', 'no': option.type == 'no', 'continue': option.type == 'continue', }" :to="{ name: 'Question', params: { id: option.id } }">
          <span v-if="option.type == 'continue'">DEVAM ET</span>
          <span v-if="option.type == 'yes'">EVET</span>
          <span v-if="option.type == 'no'">HAYIR</span>
        </router-link>

        <a
          v-if="input.isActive"
          v-on:click="onSubmit"
          :class="{
            'yes': option.type == 'yes',
            'no': option.type == 'no',
            'continue': option.type == 'continue',
          }"
        >
          <span v-if="option.type == 'continue'">DEVAM ET</span>
          <span v-if="option.type == 'yes'">EVET</span>
          <span v-if="option.type == 'no'">HAYIR</span>
        </a>

        <a
          v-if="option.isHttpRequest"
          v-on:click="option.onClick"
          :class="{
            'yes': option.type == 'yes',
            'no': option.type == 'no',
            'continue': option.type == 'continue',
          }"
        >
          <span v-if="option.type == 'continue'">DEVAM ET</span>
          <span v-if="option.type == 'yes'">EVET</span>
          <span v-if="option.type == 'no'">HAYIR</span>
        </a>

        <router-link v-if="option.type === 'done'" class="continue" :to="{ name: 'Success' }">
          <span>BİTİR</span>
        </router-link>
      </div>

      <router-link class="not-these" :to="{ name: 'Contact', query: { gim: '1' }}">
        Bunların Dışında
        <span class="go-icon">
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Question',
  data() {
    return {
      contents: [],
      options: [],
      inputVal: '',
      secondInputVal: '',
      input: {
        isActive: false,
        placeholder: null,
        value: null,
      },
      secondInput: {
        isActive: false,
        placeholder: null,
        value: null,
      },
      onSubmit: null,
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route() {
      this.fetchData();
    },
  },
  methods: {
    fetchData() {
      // Venus v3
      if (this.$route.params.id == 3) {
        this.contents = [
          {
            text: `Sim kartınızı 4.5 G uyumlu sim kartla değiştirmeli ve operatör üzerinden 4.5 G başvurusu yapmanızı rica ediyoruz.
                  Başvurunuzu yaptıysanız adımları takip ederek ayarlarınızı yapabilirsiniz.`,
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 4,
          },
        ];
      }

      if (this.$route.params.id == 4) {
        this.contents = [
          {
            text: 'Ana menüde orta kısımda bulunan <b>menü</b> tuşuna basarak menüye giriniz.',
            image: 'https://s3.eu-central-1.amazonaws.com/cdn.tus.la/buton.png',
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 5,
          },
        ];
      }

      if (this.$route.params.id == 5) {
        this.contents = [
          {
            text: 'Ayarlar seçeneğine giriş yapınız.',
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 6,
          },
        ];
      }

      if (this.$route.params.id == 6) {
        this.contents = [
          {
            text: 'Açılan sayfada diğer seçeneğini tuşlayınız. ',
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 7,
          },
        ];
      }

      if (this.$route.params.id == 7) {
        this.contents = [
          {
            text: 'Açılan sayfada Hücresel Ağlar‘a giriş yapınız.',
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 8,
          },
        ];
      }

      if (this.$route.params.id == 8) {
        this.contents = [
          {
            text: 'Açılan sayfada Tercih edilen ağ türü‘ne giriş yapınız.',
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 9,
          },
        ];
      }

      if (this.$route.params.id == 9) {
        this.contents = [
          {
            text: 'Açılan sayfada GSM/WCDMA/LTE seçeneği seçiniz. Telefonunuzu 4.5G destekli kullanmaya başlayabilirsiniz. Bu şekilde 4.5 G ayarlarınızı tamamlamış oldunuz.',
          },
        ];

        this.options = [
          {
            type: 'done',
            isOption: false,
          },
        ];
      }

      // Venus 5.5
      if (this.$route.params.id == 10) {
        this.contents = [
          {
            text: 'Sim kartınızı 4.5 G uyumlu sim kartla değiştirmeli ve operatör üzerinden 4.5 G başvurusu yapmanızı rica ediyoruz. Başvurunuzu yaptıysanız adımları takip ederek ayarlarınızı yapabilirsiniz.',
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 11,
          },
        ];
      }

      if (this.$route.params.id == 11) {
        this.contents = [
          {
            text: 'Ana menüde sağ kısımda bulunan menü tuşuna basarak menüye giriniz.',
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 12,
          },
        ];
      }

      if (this.$route.params.id == 12) {
        this.contents = [
          {
            text: 'Ayarlar seçeneğine giriş yapınız.',
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 13,
          },
        ];
      }

      if (this.$route.params.id == 13) {
        this.contents = [
          {
            text: 'Açılan sayfada mobil verilere giriş yapınız.',
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 14,
          },
        ];
      }

      if (this.$route.params.id == 14) {
        this.contents = [
          {
            text: 'Açılan sayfada Tercih edilen ağ modu’na giriş yapınız.',
          },
        ];

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 15,
          },
        ];
      }

      if (this.$route.params.id == 15) {
        this.contents = [
          {
            text: 'Açılan sayfada GSM/ WCDMA/ LTE seçeneğini seçiniz. Telefonunuzu  4.5G destekli kullanmaya başlayabilirsiniz. Bu şekilde 4.5 G ayarlarınızı tamamlamış oldunuz.',
          },
        ];

        this.options = [
          {
            type: 'done',
            isOption: false,
          },
        ];
      }

      if (this.$route.params.id == 16) {
        this.contents = [
          {
            text: 'İşlem yapmak istediğiniz numarayı başında 0 olmadan 10 haneli olacak şekilde tuşlayınız.',
          },
        ];

        this.input = {
          isActive: true,
          placeholder: '5*******',
        };
        this.secondInput = {
          isActive: false,
        };
        this.onSubmit = () => {
          localStorage.setItem('customerPhoneNumber', this.inputVal);
          axios
            .get(`https://proxy-server.tusla.com.tr/windesk/app/webroot/integration/tuslaServices.php?action=checkCallStatus_first&username=tuslaWS&password=tslSrvcs&ani=${this.inputVal}&dnis=tuslaIVR&uniqueid=12343&new_phone=${this.inputVal}`)
            .then(res => res.data)
            .then((res) => {
              this.inputVal = '';
              if (res.result.isCustomerExist === 'none') {
                // If customer doesn't exist, get informations of user
                localStorage.setItem('step29', JSON.stringify(res));
                this.$router.push({
                  name: 'Question',
                  params: {
                    id: 29,
                  },
                });
              } else if (res.result.isCustomerExist === 'exist') {
                localStorage.setItem('step17', JSON.stringify(res));
                this.$router.push({
                  name: 'Question',
                  params: {
                    id: 17,
                  },
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
        };

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 17,
          },
        ];
      }

      if (this.$route.params.id == 30) {
        this.contents = [
          {
            text: 'İşlem yapmak istediğiniz Hizmet Talep No, Seri No veya IMEI no numarasını tuşlayınız. <br><br> <i>Hizmet Talep No: Vestel ürünleriniz için hizmet almış iseniz aldığınız hizmet sonunda size bırakılan servis fişinin üzerinde ya da sistemimizde kayıtlı olan cep telefonunuza gönderilmiş olan SMS’in içerisinde 8 ile başlayan numaradır.</i>',
          },
        ];

        this.input = {
          isActive: true,
          placeholder: '80******',
        };
        this.secondInput = {
          isActive: false,
        };
        this.onSubmit = () => {
          axios
            .get(`https://proxy-server.tusla.com.tr/windesk/app/webroot/integration/tuslaServices.php?action=checkCallStatus_first&username=tuslaWS&password=tslSrvcs&ani=5056970162&dnis=tuslaIVR&uniqueid=12343&new_phone=5056970162&crmno=${this.inputVal}`)
            .then(res => res.data)
            .then((res) => {
              if (res.result.open === 'none') {
                const resultObj = {
                  result: {
                    reason: 'Kayıt bulunamadı.',
                  },
                };
                localStorage.setItem('step18', JSON.stringify(resultObj));
                this.$router.push({
                  name: 'Question',
                  params: {
                    id: 18,
                  },
                });
              } else {
                localStorage.setItem('step18', JSON.stringify(res));
                this.$router.push({
                  name: 'Question',
                  params: {
                    id: 18,
                  },
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
        };

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 17,
          },
        ];
      }

      if (this.$route.params.id == 29) {
        this.contents = [
          {
            text: 'İsim ve soyisim bilgilerinizi tuşlar mısınız?',
          },
        ];

        this.input = {
          isActive: true,
          placeholder: 'İsim',
        };
        this.secondInput = {
          isActive: true,
          placeholder: 'Soyisim',
        };

        this.onSubmit = () => {
          const step29result = JSON.parse(localStorage.getItem('step29'));
          axios
            .get(`https://proxy-server.tusla.com.tr/windesk/app/webroot/integration/tuslaServices.php?action=checkCallStatus_second&username=tuslaWS&password=tslSrvcs&ani=${localStorage.getItem('customerPhoneNumber')}&dnis=tuslaIVR&new_phone=${localStorage.getItem('customerPhoneNumber')}&callcode=${step29result.result.callcode}&partnerno=${step29result.result.partnerno}&firstname=${this.inputVal}&lastname=${this.secondInputVal}`)
            .then(res => res.data)
            .then((res) => {
              if (res.result.open === 'none') {
                const resultObj = {
                  result: {
                    reason: 'Kayıt bulunamadı.',
                  },
                };
                localStorage.setItem('step18', JSON.stringify(resultObj));
                this.$router.push({
                  name: 'Question',
                  params: {
                    id: 18,
                  },
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
        };

        this.options = [
          {
            type: 'continue',
            isOption: false,
            id: 17,
          },
        ];
      }

      if (this.$route.params.id == 17) {
        const step17result = JSON.parse(localStorage.getItem('step17'));
        let firstname = step17result.result.firstname;
        let lastname = step17result.result.lastname;

        firstname = firstname.substring(0, firstname.length / 2).padEnd(firstname.length, '*');
        lastname = lastname.substring(0, lastname.length / 2).padEnd(lastname.length, '*');

        this.contents = [
          {
            text: `Girmiş olduğunuz numaraya ait ${firstname} ${lastname} kayıtlarına ulaşıldı. Kayıt size mi ait?`,
          },
        ];

        this.input = {
          isActive: false,
        };
        this.secondInput = {
          isActive: false,
        };

        this.options = [
          {
            type: 'yes',
            isOption: false,
            isHttpRequest: true,
            onClick: () => {
              axios
                .get(`https://proxy-server.tusla.com.tr/windesk/app/webroot/integration/tuslaServices.php?action=checkCallStatus_second&username=tuslaWS&password=tslSrvcs&ani=${localStorage.getItem('customerPhoneNumber')}&dnis=tuslaIVR&new_phone=${localStorage.getItem('customerPhoneNumber')}&callcode=${step17result.result.callcode}&partnerno=${step17result.result.partnerno}&firstname=${step17result.result.firstname}&lastname=${step17result.result.lastname}`)
                .then(res => res.data)
                .then((res) => {
                  if (res.result.open === 'one') {
                    localStorage.setItem('step18', JSON.stringify(res));
                    this.$router.push({
                      name: 'Question',
                      params: {
                        id: 18,
                      },
                    });
                  } else if (res.result.open === 'many') {
                    localStorage.setItem('step19', JSON.stringify(res));
                    this.$router.push({
                      name: 'Question',
                      params: {
                        id: 19,
                      },
                    });
                  } else if (res.result.open === 'none') {
                    const resultObj = {
                      result: {
                        reason: 'Kayıt bulunamadı.',
                      },
                    };
                    localStorage.setItem('step18', JSON.stringify(resultObj));
                    this.$router.push({
                      name: 'Question',
                      params: {
                        id: 18,
                      },
                    });
                  }
                })
                .catch((err) => {
                  console.error(err);
                });
            },
            id: 18,
          },
          {
            type: 'no',
            isOption: false,
            isHttpRequest: false,
            id: 29,
          },
        ];
      }

      if (this.$route.params.id == 18) {
        const step18result = JSON.parse(localStorage.getItem('step18'));
        this.contents = [
          {
            text: `Sonuç: ${step18result.result.reason}`,
          },
        ];

        this.input = {
          isActive: false,
        };
        this.secondInput = {
          isActive: false,
        };

        this.options = [
          {
            type: 'done',
            isOption: false,
            isHttpRequest: false,
          },
        ];
      }

      if (this.$route.params.id == 91) {
        this.contents = [
          {
            text: 'Venus için <a href="https://youtu.be/rV13eSOwfwg" target="_blank">https://youtu.be/rV13eSOwfwg</a> linkine tıklayarak detaylı anlatım videomuzu izleyebilirsiniz.',
          },
        ];

        this.options = [
          {
            type: 'done',
            isOption: false,
          },
        ];
      }

      if (this.$route.params.id == 92) {
        this.contents = [
          {
            text: 'Tablet için <a href="https://youtu.be/IC1uzYClOAk" target="_blank">https://youtu.be/IC1uzYClOAk</a> linkine tıklayarak detaylı anlatım videomuzu izleyebilirsiniz.',
          },
        ];

        this.options = [
          {
            type: 'done',
            isOption: false,
          },
        ];
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .question {
    height: 435px;

    .content {
      max-height: 285px;
      overflow-y: scroll;
    }


    input {
      border: 1px solid #8a8a8a;
      padding: 5px 10px;
    }
  }

  .button-container {
    height: 120px;
    border-top: 1px solid rgba(214, 205, 205, 0.45);
    position: absolute;
    bottom: 30px;
    width: 100%;
  }

  .not-these {
    text-decoration: none;
    display: block;
    clear: both;
    margin: 10px auto;
    margin-bottom: 20px;
    width: 85%;
    box-sizing: border-box;
    padding: 15px 20px;
    text-align: left;
    font-size: 14px;
    background: #3586ad;
    color: #fff;
    border-radius: 4px;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);

    i {
      float: right;
    }
  }

  .button-caption {
    float: left;
    width: 100%;
    min-width: 50%;
    padding: 0 5px;
    box-sizing: border-box;

    a {
      text-decoration: none;
      border-radius: 4px;
      color: #FFFFFF;
      font-size: 14px;
      display: block;
      width: 75%;
      margin: 10px 0;
      padding: 10px;
      cursor: pointer;

      &.no {
        background: #E45D5D;
        float: left;
      }

      &.yes {
        background: #33BFA0;
        float: right;
      }

      &.continue {
        width: 50%;
        background-color: #2B7EED;
        display: inline-block;
      }
    }
  }

  p {
    color: #858484;
    font-size: 15px;
    padding: 10px;
    margin: 0;

    img {
      max-width: 90%;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.20);
      border-radius: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// Question.vue?7d794fb6